export const setBasketContent = payload => ({
	type: "SET_BASKET_CONTENT", payload
});